import React from 'react'

import Button from "../../../../core/gd-components/buttons/gd-button/gd-button-ui5-new"
import RequestForm from "../../../../core/model2/form/request-form";

type Props = {
    requestForm     : RequestForm

    onNewRequest    : {():void}
}

export default function RequestFormSubmissionConfirmation(props:Props) {
    return (
        <div className="confirmation">
            <div className="message w-500">
                <div className="title">{props.requestForm.settings.confirmationTitle}</div>

                <div className="ui5-txt-no-accent-small">
                    {props.requestForm.settings.confirmationMessage}
                </div>
            </div>

            <Button className   = "w-150"
                    type        = "primary"
                    size        = "36"
                    label       = "New request"
                    onClick     = {props.onNewRequest} />
        </div>
    )
}
